/**
 * Service for managing customer orders
 */

import api from './api';

class OrderService {
  /**
   * Get list of orders with filtering
   */
  async getOrders(filters = {}) {
    try {
      const params = {};

      if (filters.status) params.status = filters.status;
      if (filters.customer_id) params.customer_id = filters.customer_id;
      if (filters.location_id) params.location_id = filters.location_id;
      if (filters.search) params.search = filters.search;
      if (filters.page) params.page = filters.page;
      if (filters.limit) params.limit = filters.limit;

      const response = await api.get('/orders', { params });
      const data = response.data;
      return {
        success: true,
        data: data.data,
        message: data.message
      };
    } catch (error) {
      console.error('Error fetching orders:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  /**
   * Get specific order details
   */
  async getOrder(orderId) {
    try {
      const response = await api.get(`/orders/${orderId}`);
      const data = response.data;
      return {
        success: true,
        data: data.data,
        message: data.message
      };
    } catch (error) {
      console.error('Error fetching order:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  /**
   * Create new order
   */
  async createOrder(orderData) {
    try {
      const response = await api.post('/orders', orderData);
      const data = response.data;
      return {
        success: true,
        data: data.data,
        message: data.message
      };
    } catch (error) {
      console.error('Error creating order:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  /**
   * Update order
   */
  async updateOrder(orderId, updateData) {
    try {
      const response = await api.put(`/orders/${orderId}`, updateData);
      const data = response.data;
      return {
        success: true,
        data: data.data,
        message: data.message
      };
    } catch (error) {
      console.error('Error updating order:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  /**
   * Delete order
   */
  async deleteOrder(orderId) {
    try {
      const response = await api.delete(`/orders/${orderId}`);
      const data = response.data;
      return {
        success: true,
        data: data.data,
        message: data.message
      };
    } catch (error) {
      console.error('Error deleting order:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  // USUNIETE: generateReceipt(orderId) -> GET /orders/{id}/receipt.
  // Metoda nie byla wolana przez zaden komponent, a endpoint zwracal fantomowy
  // 'receipt_number' w formacie PAR-ZAM-... - ten sam przedrostek co realne
  // paragony z document_prefixes. Numer paragonu nadaje wylacznie POS przy
  // finalizacji sprzedazy.

  /**
   * Get orders statistics
   */
  async getOrdersStats(locationId = null) {
    try {
      const params = {};
      if (locationId) params.location_id = locationId;

      const response = await api.get('/orders/stats', { params });
      const data = response.data;
      return {
        success: true,
        data: data.data,
        message: data.message
      };
    } catch (error) {
      console.error('Error fetching orders stats:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  /**
   * Search products for adding to order
   */
  async searchProducts(query, locationId = null, limit = 20) {
    try {
      const params = { query, limit };

      // Dodaj location_id jeśli podano
      if (locationId) {
        params.location_id = locationId;
      }

      const response = await api.get('/products/search', { params });
      const data = response.data;
      return {
        success: true,
        data: data.data?.products || [],
        message: data.message
      };
    } catch (error) {
      console.error('Error searching products:', error);
      return {
        success: false,
        error: error.message,
        data: []
      };
    }
  }

  /**
   * Get order statistics
   */
  async getStats(timeframe = 'today') {
    try {
      const response = await api.get('/orders/stats', { params: { timeframe } });
      const data = response.data;
      return {
        success: true,
        data: data.data || data,
        message: data.message
      };
    } catch (error) {
      console.error('Error fetching order stats:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
}

export const orderService = new OrderService();
export default orderService;
